module.exports = __webpack_public_path__ + "img/fangan.876b9275.png";